import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    user: {
        _id: null,
        email: null,
        userType: null,
        role: null,
        firstName: null,
        lastName: null,
        fullName: null
    },
    isLoggedIn: false
};

export const sliceName = 'auth'

export const loginAuth = createSlice({
    name: sliceName,
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        setUserCredentials: (state, action) => {
            state.user = action.payload.user
            state.isLoggedIn = true
        },
        resetUserCredentials: (state, action) => {
            return initialState;
        }
    }
});

export const { setUserCredentials, resetUserCredentials } = loginAuth.actions;

export const selectUser = (state) => state[sliceName].user;
export const selectUserRole = (state) => state[sliceName].user.role;
export const selectIsUserLoggedIn = (state) => state[sliceName].isLoggedIn;

export default loginAuth.reducer;
